import React from "react";
import { BaseModelOptions } from '@projectstorm/react-canvas-core';
import BotMessageForm from "../../../../widgetForm/BotMessageForm/BotMessageForm";
import UserIntentForm from "../../../../widgetForm/UserIntentForm/UserIntentForm";
import { BotMessageNodeModel, UserIntentNodeModel, ActionNodeModel } from "../../../../../../model/workflowEditor";
import { LinkModel } from "../../../../../../model/workflowEditor/link/LinkModel";
import LinkForm from "../../../../widgetForm/linkForm/LinkForm";
import { Flow } from "../../../../../../model/workflowEditor/flow/types";

type FormWrapperProps = {
  node: BaseModelOptions;
  flow: Flow;
};

const FormWrapper: React.FunctionComponent<FormWrapperProps> = ({
  node,
  flow
}) => {
  const renderForm = () => {
    switch (true) {
      // @ts-ignore
      case node.entity instanceof BotMessageNodeModel:
        // @ts-ignore
        return <BotMessageForm node={node.entity as BotMessageNodeModel} />

      // @ts-ignore
      case node.entity instanceof ActionNodeModel:
        // @ts-ignore
        return <BotMessageForm node={node.entity as BotMessageNodeModel} />

      //@ts-ignore
      case node.entity instanceof UserIntentNodeModel:
        //@ts-ignore
        return <UserIntentForm node={node.entity as UserIntentNodeModel} />

      //@ts-ignore
      case node.entity instanceof LinkModel:
        //@ts-ignore
        return <LinkForm link={node.entity} flow={flow}></LinkForm>
      default:
        break;
    }
    return null;
  }
  return (
    renderForm()
  );
};

export default FormWrapper;